<div *ngIf="reportType == 'Briefly-OfficerCredit'">
   
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="2">Vivek Saptahik</th>
                    <th colspan="4">Advt. Credit Note Register</th>
                    <th colspan="3">Date {{currentDate | date:'dd-MM-yyy' }} </th>
                </tr>
                <tr>
                    <th colspan="4" style="font-size: 14px;">Briefly-Officer</th>
                    <th colspan="5" style="font-size: 14px;">Date From {{startDate}} To {{endDate}}</th>
                </tr>
                <tr>
                    <th style="text-align: center;font-size: small;">Credit Note No.</th>
                    <th style="text-align: center;font-size: small;">CR Date</th>
                    <th style="text-align: center;font-size: small;">Advertiser Name</th>
                    <th style="text-align: center;font-size: small;">Representative Name</th>
                    <th style="text-align: center;font-size: small;">Office <br>Rep Name</th>
                    <th colspan="2" style="text-align: center;font-size: small;">Credit Note Amount</th>
                    <th style="text-align: center;font-size: small;">Total Credit <br> Amount</th>
                    <th style="text-align: center;font-size: small;">Remark</th>
                </tr>

                <tr>
                    <th colspan="5"></th>
                    <th style="text-align: center;font-size: medium;">TDS</th>
                    <th style="text-align:center;font-size: medium;">Other</th>
                    <th></th>
                </tr>
            </thead>

            <tbody *ngFor="let data of CreditNoteVFormBeans; let i = index">
                <!-- Office Representative Header -->
                <tr>
                    <td colspan="2" style="font-weight: bold; font-size: 15px; background-color: #f8f9fa;">
                        Office Representative
                    </td>
                    <td colspan="6" style="font-weight: bold; font-size: 15px; background-color: #f8f9fa;">
                        {{data.office_rep}}
                    </td>
                </tr>
                
                <!-- Loop through grouped representatives -->
                <ng-container *ngFor="let rep of data.grouped_rep_data; let j = index">
                    <!-- Representative Header -->
                    <tr style="background-color: #e3f2fd;">
                        <td colspan="3" style="font-weight: bold; font-size: 14px;">
                            Representative: {{rep.rep_name}}
                        </td>
                        <td colspan="5"></td>
                    </tr>
                    
                    <!-- Representative Data Rows -->
                    <tr *ngFor="let item of rep.items">
                        <td style="font-size: 16px;">{{item.credit_voc_no}}</td>
                        <td style="font-size: 16px;">{{item.voc_date}}</td>
                        <td style="font-weight: bold;font-size: 16px;">{{item.advt_name | slice:0:30}}</td>
                        <td style="font-size: 16px;">{{item.rep_name | slice : 0 : 15}}</td>
                        <td style="font-size: 16px;">{{data.office_rep}}</td>
                        <td style="text-align: end;font-weight: bold;font-size: 16px;">
                            {{(item.tds_amt * 1).toFixed(2)}}
                        </td>
                        <td style="text-align: end;font-weight: bold;font-size: 16px;">
                            {{(item.other_credit_amt * 1).toFixed(2)}}
                        </td>
                        <td style="text-align: end;font-weight: bold;font-size: 16px;">
                            {{(item.credit_amt * 1).toFixed(2)}}
                        </td>
                        <td style="font-size: 16px;text-align: left;">{{item.credit_remark}}</td>
                    </tr>
                    
                    <!-- Representative Total -->
                    <tr style="background-color: #e3f2fd;">
                        <td colspan="5" style="font-weight: bold; text-align: end; font-size: 15px;">
                            Representative Total ({{rep.rep_name}}):
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 15px;">
                            {{rep.tds_amt.toFixed(2)}}
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 15px;">
                            {{rep.other_credit_amt.toFixed(2)}}
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 15px;">
                            {{rep.total.toFixed(2)}}
                        </td>
                        <td></td>
                    </tr>
                </ng-container>

                <!-- Office Representative Total -->
                <tr style="background-color: #f8f9fa;">
                    <td colspan="5" style="font-weight: bold; text-align: end; font-size: 17px;">
                        Office Total ({{data.office_rep}}):
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 17px;">
                        {{(data.tds_amt * 1).toFixed(2)}}
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 17px;">
                        {{(data.other_credit_amt * 1).toFixed(2)}}
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 17px;">
                        {{(data.total * 1).toFixed(2)}}
                    </td>
                    <td></td>
                </tr>
            </tbody>

            <!-- Grand Total -->
            <tbody>
                <tr>
                    <td colspan="5" style="text-align: center; font-weight: bold; background-color: #e9ecef !important; font-size: 18px;">
                        Grand Total:
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef !important; font-size: 18px;">
                        {{(CreditadvtOffBrieflyTotalTds * 1).toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef !important; font-size: 18px;">
                        {{(CreditadvtOffBrieflyTotalOther * 1).toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef !important; font-size: 18px;">
                        {{(CreditadvtOffBrieflyTotal * 1).toFixed(2)}}
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
       
    </div>
    <div style="margin-left: 80%;  margin-bottom: 2%;">
        <button 
            class="noPrint" 
            style="margin: 2% 2% 0 2%;" 
            (click)="exportExcel('Datewise_Subscription_Report')" 
            mat-raised-button 
            color="primary">
            Export
        </button>

        <button class="no-print" style="margin-top: 2%; margin-right: 2%" 
            (click)="printPageA4Portrait()" mat-raised-button color="primary">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>